import { motion } from "framer-motion";
import { Reveal, Overline } from "../Reveal";
import { PIPELINE } from "../../data";

const phaseColor = (phase) => {
  if (phase.includes("II")) return "text-brand";
  if (phase.includes("Phase I")) return "text-zinc-900";
  return "text-zinc-400";
};

export default function Pipeline() {
  return (
    <section
      id="pipeline"
      data-testid="pipeline-section"
      className="relative bg-white py-28 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <Reveal>
              <Overline>Pipeline</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-zinc-900 mt-6 leading-tight">
                Programs advancing toward the clinic.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="font-mono text-xs tracking-wider uppercase text-zinc-500 max-w-xs lg:text-right">
              Five disclosed programs across oncology, rare disease and immunology.
            </p>
          </Reveal>
        </div>

        {/* header row */}
        <div className="hidden md:grid grid-cols-12 gap-4 mt-16 pb-4 border-b border-black/10 font-mono text-[11px] tracking-widest uppercase text-zinc-400">
          <div className="col-span-2">Program</div>
          <div className="col-span-2">Area</div>
          <div className="col-span-3">Indication</div>
          <div className="col-span-3">Stage</div>
          <div className="col-span-2 text-right">Phase</div>
        </div>

        <div>
          {PIPELINE.map((p, i) => (
            <Reveal key={p.code} delay={i * 0.06}>
              <div
                data-testid={`pipeline-row-${p.code}`}
                className="group grid grid-cols-2 md:grid-cols-12 gap-x-4 gap-y-3 items-center py-6 border-b border-black/10 hover:bg-zinc-50/70 transition-colors px-2 -mx-2 rounded-lg"
              >
                <div className="col-span-2 md:col-span-2 font-heading text-lg font-medium text-zinc-900 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand group-hover:scale-150 transition-transform" />
                  {p.code}
                </div>
                <div className="col-span-2 md:col-span-2 font-body text-sm text-zinc-600">
                  {p.area}
                </div>
                <div className="col-span-2 md:col-span-3 font-body text-sm text-zinc-600">
                  {p.indication}
                </div>
                <div className="col-span-2 md:col-span-3">
                  <div className="h-1.5 w-full bg-zinc-100 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${p.progress}%` }}
                      viewport={{ once: true }}
                      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
                      className="h-full bg-brand rounded-full"
                    />
                  </div>
                </div>
                <div
                  className={`col-span-2 md:col-span-2 font-mono text-xs tracking-wider uppercase md:text-right ${phaseColor(
                    p.phase
                  )}`}
                >
                  {p.phase}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
